/* eslint-disable react/no-danger */
import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import "../../css/authorpage.scss";
import attrib from "../util";
import logo from "../../assets/images/icon.png";

const AuthorPage = ({ data }) => {
  document.title = `Queer in Color | ${data.name}`;
  const { essays } = data;
  const blocks = essays.map((essay) => (
    <article key={essay.title}>
      {data.content === "essays" ?
        <section className="background" style={{ backgroundImage: `url(${essay.img})` }}>
          <section className="filter" />
          <section className="foreground">
            <div>
              {(essay.excerpt) &&
                <div
                  className="excerpt"
                  dangerouslySetInnerHTML={{ __html: `&ldquo;${attrib(essay.excerpt)}&rdquo;` }}
                />}
              <div className="title">
                <a target="_blank" rel="noreferrer" href={essay.link}>
                  {essay.title} &#x2197;
                </a>
              </div>
            </div>
          </section>
        </section> :
        <section className="full-image">
          <img src={essay.img} alt={essay.title} />
          <div className="title">
            <a target="_blank" rel="noreferrer" href={essay.link}>
              {essay.title} &#x2197;
            </a>
          </div>
        </section>}
    </article>
  ));

  return (
    <>
      <nav>
        <div className="left">
          <img src={logo} alt="The Michigan Daily logo" />
          <Link to="/" className="title">QUEER IN COLOR</Link>
        </div>
        <Link to="/#features" className="gallery">FEATURES &#x2197;</Link>
      </nav>
      <header>
        <h1 style={{ color: data.textcolor }}>{data.name}</h1>
      </header>
      {data.content === "essays" ?
        <div className="author-page">
          <main>
            {blocks}
            <section className="bio">
              <div>
                {
                  data.slug !== "anonymous" && (
                    <div className="about">
                      <h2>ABOUT THE AUTHOR</h2>
                      <p dangerouslySetInnerHTML={{ __html: attrib(data.bio) }} />
                    </div>
                  )
                }
                <Link to="/#features">
                  <button type="button">
                    <span className="return">RETURN</span> TO FEATURES &#x2197;
                  </button>
                </Link>
              </div>
            </section>
          </main>
        </div>
        : <div className="artist-page">
          <main>
            {blocks}
            <section className="bio">
              <div>
                {
                  data.slug !== "anonymous" && (
                    <div className="about">
                      <h2>ABOUT THE ARTIST</h2>
                      <p dangerouslySetInnerHTML={{ __html: attrib(data.bio) }} />
                    </div>
                  )
                }
                <Link to="/#features">
                  <button type="button">
                    <span className="return">RETURN</span> TO FEATURES &#x2197;
                  </button>
                </Link>
              </div>
            </section>
          </main>
        </div>}
    </>
  );
};

AuthorPage.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    textcolor: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    bio: PropTypes.string.isRequired,
    essays: PropTypes.arrayOf(
      PropTypes.shape({
        excerpt: PropTypes.string.isRequired,
        link: PropTypes.string,
        title: PropTypes.string.isRequired,
        img: PropTypes.string,
        alttext: PropTypes.string,
      })
    ),
  }),
};

AuthorPage.defaultProps = {
  data: undefined
}

export default AuthorPage;
